export default {
  namespaced: true,

  state: {
    hasData: false,
    hasDomainInfo: false,
    info: [],
    current: [],
    invitations: [],
    switchingTeam: false,
    updateKey: 0,
    availableServices: false,
    modalData: false,
    updateKeyForm: 0,
    selectedTeam: false,
  },

  getters: {
    hasInvitation() {
      if (localStorage.getItem('invitation_code') !== null) {
        return true;
      } else {
        return false;
      }
    }
  },

  mutations: {
    HAS_DATA(state, bool) {
      state.hasData = bool;
    },

    HAS_DOMAIN_INFO(state, bool) {
      state.hasDomainInfo = bool;
    },

    ADD(state, team) {
      state.info.push(team);
    },

    SET(state, team) {
        let data = [...team].reverse();
        state.info = team;
    },

    UPDATE(state, team) {
        const item = state.info.find(item => item.id === team.id);
        item.os_domain_id = team.os_domain_id;
        if (team.projects && team.projects.length > 0) {
            item.projects = team.projects;
        }
    },

    UPDATE_SINGLE(state, team) {
        let otherTeams = state.info.filter(item => item.id !== team.id);
        otherTeams.push(team);
        state.info = otherTeams;
    },

    SET_CURRENT(state, team) {
      state.current = team;
    },

    SET_SELECTED(state, team) {
      state.selectedTeam = team;
    },

    ADD_DOMAIN_INFO(state, team) {
      state.current.domain = team;
    },

    ADD_DOMAIN_DATA(state, domain) {
        state.current.domain = domain[0];
    },

    SWITCHING_TEAM(state, bool) {
      state.switchingTeam = bool;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },

    UPDATE_KEY_FORM(state) {
      state.updateKeyForm += 1;
    },

    SET_INVITATIONS(state, invitee) {
      state.invitations = invitee;
    },

    SET_AVAILABLE_SERVICES(state, services) {
      state.availableServices = services;
    },

    SET_MODAL_DATA(state, services) {
      state.modalData = services;
    },

    UPDATE_PROJECT(state, projectData) {
      const projectToBeEdited = state.current.projects.find(item => item.id === projectData.id);
      projectToBeEdited.name = projectData.name;
      projectToBeEdited.description = projectData.description;
      let projects = state.current.projects.filter(item => item.id !== projectData.id);
      projects.push(projectToBeEdited);
      state.current.projects = projects;
      state.updateKey += 1;
    },

    UPDATE_NAMESPACE(state, projectData) {
      const projectToBeEdited = state.current.emk_projects.find(item => item.id === projectData.id);
      projectToBeEdited.extra = projectData.extra;
      let projects = state.current.emk_projects.filter(item => item.id !== projectData.id);
      projects.push(projectToBeEdited);
      state.current.emk_projects = projects;
      state.updateKey += 1;
    },

    ADD_PROJECT(state, projectData) {
      state.current.projects.push(projectData);
      state.updateKey += 1;
    },
  },

  actions: {
    ADD(context, team) {
      context.commit('ADD', team);
    },

    SET(context, team) {
      context.commit('SET', team);
    },

    PATCH(context, team) {
      context.commit('PATCH', team);
    },

    SET_CURRENT(context, team) {
      context.commit('SET_CURRENT', team);
    },

    SET_SELECTED(context, team) {
      context.commit('SET_SELECTED', team);
    },

    ADD_DOMAIN_INFO(context, team) {
      context.commit('ADD_DOMAIN_INFO', team);
    },

    // PATCH_CURRENT_TEAM_USERS(context, users) {
    //   context.commit('PATCH_CURRENT_TEAM_USERS', users);
    // },

    SET_INVITATIONS(context, invitee) {
      context.commit('SET_INVITATIONS', invitee);
    },
  }
}
